<template>
  <div 
    class="modal fade" 
    id="authModal" 
    tabindex="-1" 
    aria-labelledby="authModalLabel" 
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" :class="{ 'modal-lg': activeTab !== 'forgot', 'modal-md': activeTab === 'forgot' }">
      <div class="modal-content">
        <div class="modal-header border-0">
          <button 
            type="button" 
            class="btn-close" 
            data-bs-dismiss="modal" 
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body p-5 pt-0">
          <!-- Tab Navigation -->
          <div class="d-flex justify-content-center mb-4">
            <ul class="nav nav-pills" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'login' }"
                  @click="switchTab('login')"
                  type="button"
                >
                  Accedi
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'register' }"
                  @click="switchTab('register')"
                  type="button"
                >
                  Registrati
                </button>
              </li>
              <!--<li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  :class="{ active: activeTab === 'forgot' }"
                  @click="switchTab('forgot')"
                  type="button"
                >
                  Password Dimenticata
                </button>
              </li>-->
            </ul>
          </div>

          <!-- Tab Content -->
          <div class="tab-content">
            <div
              v-if="activeTab === 'login'"
              class="tab-pane fade show active"
            >
              <Login
                @login-success="handleAuthSuccess"
                @switch-to-register="switchTab('register')"
                @switch-to-forgot="switchTab('forgot')"
              />
            </div>
            <div
              v-if="activeTab === 'register'"
              class="tab-pane fade show active"
            >
              <Register
                @register-success="handleAuthSuccess"
                @switch-to-login="switchTab('login')"
              />
            </div>
            <div
              v-if="activeTab === 'forgot'"
              class="tab-pane fade show active"
            >
              <ForgotPassword
                :isModal="true"
                @forgot-success="handleForgotSuccess"
                @switch-to-login="switchTab('login')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import Login from '@/components/Modules/Authentication/Login/index.vue';
import Register from '@/components/Modules/Authentication/Register/index.vue';
import ForgotPassword from '@/components/Modules/Authentication/ForgotPassword/index.vue';

export default defineComponent({
  name: 'AuthModal',
  components: {
    Login,
    Register,
    ForgotPassword
  },
  setup() {
    const activeTab = ref('login');

    const switchTab = (tab: 'login' | 'register' | 'forgot') => {
      activeTab.value = tab;
    };

    const handleAuthSuccess = () => {
      const modalElement = document.getElementById('authModal');
      if (modalElement) {
        const closeButton = modalElement.querySelector('.btn-close[data-bs-dismiss="modal"]');
        if (closeButton) {
          (closeButton as HTMLElement).click(); // Simulate click
        }
      }
    };

    const handleForgotSuccess = () => {
      // After successful password reset request, switch to login tab after 10 seconds
      setTimeout(() => {
        switchTab('login');
      }, 10000); // 10 seconds
    };

    onMounted(() => {
      // Listener per reset del tab quando la modal si apre
      const modalElement = document.getElementById('authModal');
      if (modalElement) {
        modalElement.addEventListener('show.bs.modal', () => {
          // Mantieni il tab attuale, non resettare automaticamente
        });
      }

      // Listener per impostare il tab dal pulsante dell'header
      const handleSetTab = (event: any) => {
        activeTab.value = event.detail.tab;
      };
      
      window.addEventListener('setAuthModalTab', handleSetTab);

      // Cleanup
      return () => {
        window.removeEventListener('setAuthModalTab', handleSetTab);
      };
    });

    return {
      activeTab,
      switchTab,
      handleAuthSuccess,
      handleForgotSuccess
    };
  }
});
</script>

<style scoped>
.nav-pills .nav-link {
  color: #6c757d;
  border-radius: 20px;
  margin: 0 5px;
  padding: 8px 20px;
}

.nav-pills .nav-link.active {
  background-color: #304BF7;
  color: white;
}

.nav-pills .nav-link:hover {
  color: #304BF7;
}
</style>